module.exports = __webpack_public_path__ + "img/logo.da5f2b05.png";